const heroMain = {
  title: 'PEGASUS ARMS 25',
  description:
    'Це рішення для тих, кому потрібна точність, автономність і надійність у реальному бою. Його ключове завдання на фронті — дістатися цілі, знищити її, повернутися та зберегти життя захисникам України. ',
  buttons: {
    learnMore: 'Дізнатись більше',
  },
}
export default heroMain
